import React, {useState, useEffect} from "react";
import {Grid} from "@material-ui/core";
import {configApiRef, useApi, identityApiRef} from "@backstage/core-plugin-api";
import {useEntity} from "@backstage/plugin-catalog-react";
import {SchemaEntity, SchemaEntityConfig} from "../types";

interface GoDocContentProps {
  config: SchemaEntityConfig;
}

const GoDocContent = ({config}: GoDocContentProps) => {
  const {entity} = useEntity<SchemaEntity>();
  const configApi = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const backendUrl = configApi.getString('backend.baseUrl');
  const [goDocContent, setGoDocContent] = useState('');

  useEffect(() => {
    const links = `
      <style>h1{margin: 0} .container{padding: 0px; max-width: unset} div#topbar{display:none;}</style>
      `;

    const uri = `${backendUrl}/api/proxy/godocs/${config.goDocsPath}/${entity.spec.schema.path}?showHeader=false`;

    (async () => {
      try {
        const {token} = await identityApi.getCredentials();
        const response = await fetch(uri, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const html = await response.text();
        setGoDocContent(links + html);
      } catch (e) {
        console.log('error', e);
        setGoDocContent('<div><b>Error occurred while fetching go docs, please contact DevX for any help.</b></div>');
      }
    })();
  }, [backendUrl, config.goDocsPath, entity.spec.schema.path, identityApi]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {goDocContent && <div dangerouslySetInnerHTML={{__html: goDocContent}}/>}
      </Grid>
    </Grid>
  );
};

export default GoDocContent;
